import { useEffect, useRef } from "react";

import type { RioTripsFilters } from "@types";
import { buildTripFilters } from "@utils/rioTripOptions";

export type TripFiltersRequestParams = {
  search?: string | null;
  vehicleId?: string | null;
  driverIds?: string[] | null;
  date?: string | null;
};

export const useTripFiltersRequest = (
  { search, vehicleId, driverIds, date }: TripFiltersRequestParams,
  onFiltersChange?: (filters: RioTripsFilters) => void
) => {
  const callbackRef = useRef(onFiltersChange);
  callbackRef.current = onFiltersChange;

  const chaveMotoristas = (driverIds ?? []).join(",");

  useEffect(() => {
    const filters = buildTripFilters({
      search,
      vehicleId,
      driverIds: chaveMotoristas ? chaveMotoristas.split(",") : [],
      date,
    });
    const agendamento = setTimeout(() => callbackRef.current?.(filters), 0);

    return () => clearTimeout(agendamento);
  }, [search, vehicleId, chaveMotoristas, date]);
};
